import Cookies from 'js-cookie';

$(() => {
  $(".cookies-close").click(() => {
    Cookies.set('cookieconsent_status', "dismiss", { expires: 365 });
    $("body").addClass("cookies-accepted")
  });
});
